export function showLoader() {
  const loaderSlide = document.createElement("div");
    loaderSlide.id = "loader";
    loaderSlide.className = "loader-slide";
    loaderSlide.innerHTML = `
    <div class="reviews-loader">
      <div class="spinner"></div>
      <span>Загрузка отзывов...</span>
    </div>
  `;

  return loaderSlide;
}

export function hideLoader() {
  const loaderSlide = document.getElementById('loader');
  if (!loaderSlide) return;

  loaderSlide.remove();
}